import { ContentArea } from '../Types'
import { MeshItemLayout, UnitSize } from '@wix/thunderbolt-becky-types'

export const DEFAULT_UNIT_SIZE: UnitSize = { type: 'px', value: 0 }

export const unitize = ({ type, value }: UnitSize) => `${value}${type}`

export const isDocked = (itemLayout: Partial<MeshItemLayout>): boolean => !!(itemLayout.left && itemLayout.right)

export const getLeft = (itemLayout: Partial<MeshItemLayout>) => (isDocked(itemLayout) ? 0 : unitize(itemLayout.left!))

const getDockedMargin = (itemLayout: Partial<MeshItemLayout>, dockedTo: 'left' | 'right'): string | null => {
	if (!isDocked(itemLayout)) {
		return null
	}
	const margin = itemLayout[dockedTo]
	return margin!.value ? `${margin!.value}${margin!.type}` : '0'
}

export const getMarginLeft = (itemLayout: Partial<MeshItemLayout>, contentArea: ContentArea | undefined): string =>
	getDockedMargin(itemLayout, 'left') ||
	(contentArea ? `calc((100% - ${contentArea.width}px) * ${contentArea.alignment})` : '0')

export const getMarginRight = (itemLayout: Partial<MeshItemLayout>): string =>
	getDockedMargin(itemLayout, 'right') || '0px'

export const getJustify = (itemLayout: Partial<MeshItemLayout>): 'start' | 'end' | 'stretch' => {
	if (isDocked(itemLayout)) {
		return 'stretch'
	}

	if (itemLayout.right) {
		return 'end'
	}

	return 'start'
}
